module.exports = __webpack_public_path__ + "static/media/background-14.6f32be07.jpg";